import {
  Box,
  Grid,
  IconButton,
  useMediaQuery,
  useTheme
} from "@material-ui/core"
import NCText from "../../shared/NCText"
import NCTable from "../../shared/table/NCTable"
import { useState } from "react"
import { SEARCH_CONFIG, TABLE_CONFIG } from "../../libs/config"
import { useGetAllTrainings } from "../../services/queries"
import { AddIcon, DeleteIcon, DetailIcon, SearchIcon } from "../../libs/icons"
import NCLoader from "../../shared/NCLoader"
import NCSvgIcon from "../../shared/NCSvgIcon"
import { useNavigate } from "react-router-dom"
import NCButton from "../../shared/NCButton"
import NCModal from "../../shared/NCModal"
import NCInput from "../../shared/NCInput"
import useDebounce from "../../libs/hooks/Debounce"
import { useDeleteTraining } from "../../services/mutations"
import { toast } from "react-toastify"
import { useQueryClient } from "react-query"
import { useTranslation } from "react-i18next"
import NotificationAlert from "../../components/notification/NotificationAlert"

const TrainingList = () => {
  const nav = useNavigate()

  const {t} = useTranslation();

  const deleteTrainingMutation = useDeleteTraining()

  const queryClient = useQueryClient()

  const mobileTheme = useTheme()
  const isSmallScreen = useMediaQuery(mobileTheme.breakpoints.down("sm"))

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(TABLE_CONFIG.PAGE_SIZE)
  const [query, setQuery] = useState("")
  const [ordering, setOrdering] = useState("name")
  const debouncedSearchTerm = useDebounce(query, SEARCH_CONFIG.TIME_IN_MILLI)

  const [showDeleteModel, setShowDeleteModel] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [selectedRequest, setSelectedRequest] = useState()

  const { isLoading, data, refetch } = useGetAllTrainings(
    page,
    debouncedSearchTerm,
    pageSize,
    {
      ordering
    }
  )

  const {
    next,
    previous,
    total_pages,
    results: driverData
  } = data?.data?.data || {}

  const onNext = () => {
    setPage(prev => (next ? prev + 1 : prev))
  }
  const onPrev = () => {
    setPage(prev => (previous ? prev - 1 : prev))
  }

  const deleteTraining = () => {
    deleteTrainingMutation.mutate(selectedRequest.id, {
      onSuccess: () => {
        toast.success(t("training.delete"))
        queryClient.refetchQueries(["getAllTrainings"])
        refetch();
      }
    })
  }

  const getActionColumn = cell => {
    return (
      <div className="action-icons">
        <Box display={"flex"} alignItems={"center"}>
          <IconButton
            onClick={() => {
              setShowDeleteModel(true)
              setSelectedRequest(cell)
            }}
          >
            <DeleteIcon />
          </IconButton>
          <IconButton
            onClick={() => {
              nav(`/training/${cell.id}`)
            }}
          >
            <DetailIcon />
          </IconButton>
        </Box>
      </div>
    )
  }

  const columns = [
    {
      Header: t("list.name"),
      id: "name",
      accessor: cell => cell.name
    },
    {
      Header: t("list.topic"),
      id: "created",
      accessor: cell => cell.topic,
      disableSortBy: true
    },
    {
      Header: t("list.description"),
      accessor: cell => cell.description,
      disableSortBy: true
    },
    {
      Header: t("list.total_lesson"),
      accessor: cell => cell.total_lessons,
      disableSortBy: true
    },
    {
      Header: "",
      id: "action",
      accessor: cell => getActionColumn(cell),
      disableSortBy: true
    }
  ]

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box mb={2}>
          <Grid container justifyContent="space-between" mb={20}>
            <Grid item xs={12} sm={6} md={4}>
              <NCText variant={"h4"}>{t("training.heading")}</NCText>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={8}
              style={{
                marginTop: isSmallScreen ? "10px" : "0px"
              }}
            >
              <Grid
                container
                spacing={2}
                justifyContent={isSmallScreen ? "flex-start" : "flex-end"}
              >
                <Grid item>
                  <NCInput
                    value={query}
                    onChange={e => {
                      setPage(1)
                      setOrdering(null)
                      setQuery(e.target.value)
                    }}
                    placeholder={t("common.search_here")}
                    startIcon={SearchIcon}
                    className="rounded"
                  />
                </Grid>
                <Grid item style={{ paddingRight: "0" }}>
                  <NCButton
                    variant="contained"
                    color="primary"
                    endIcon={<NCSvgIcon component={AddIcon} inheritViewBox />}
                    onClick={() => nav("/training/add-training")}
                  >
                    {t("training.add_training")}
                  </NCButton>
                </Grid>
                <Grid item style={{ paddingLeft: "0" }}>
                  <NotificationAlert />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <NCTable
          columns={columns}
          data={driverData || []}
          page={page}
          onNext={onNext}
          onPrev={onPrev}
          pageCount={total_pages}
          gotoPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          sorting={ordering}
          setSorting={setOrdering}
          isLoading={isLoading}
        />
        {isLoading && <NCLoader open={true} />}
      </Grid>
      <NCModal
        open={showDeleteModel}
        title={t("training.delete_training")}
        text={t("training.delete_confirm")}
        onClose={() => setShowDeleteModel(false)}
        submitButton={
          <NCButton
            variant="contained"
            color="secondary"
            disableElevation
            onClick={() => {
              deleteTraining()
              setShowDeleteModel(false)
            }}
            style={{ width: "auto" }}
          >
            {t("common.delete")}
          </NCButton>
        }
      />
    </Grid>
  )
}

export default TrainingList
